{
  "status": {
    "PLANNING": "قيد التخطيط",
    "ACTIVE": "نشط",
    "ON_HOLD": "متوقف مؤقتًا",
    "COMPLETED": "مكتمل",
    "CLOSED": "مغلق",
    "CANCELLED": "ملغى"
  },
  "priority": {
    "LOW": "منخفضة",
    "NORMAL": "عادية",
    "HIGH": "مرتفعة",
    "URGENT": "عاجلة"
  },
  "kind": {
    "CUSTOMER": "لعميل",
    "INTERNAL": "داخلي",
    "CUSTOMERBody": "عمل لعميل تُصدر له الفواتير.",
    "INTERNALBody": "عمل خاص بالشركة (تجهيز مقر أو تعميم نظام): تكلفة فقط ولا يُفوتر."
  },
  "billingMethod": {
    "FIXED_PRICE": "سعر مقطوع",
    "TIME_AND_MATERIALS": "الوقت والمواد",
    "PROGRESS_CLAIMS": "مستخلصات",
    "NON_BILLABLE": "لا يُفوتر"
  },
  "progressMethod": {
    "MANUAL": "بتحديثات الإنجاز",
    "TASKS": "بالمهام",
    "MILESTONES": "بالمعالم الرئيسية",
    "COST_TO_COST": "بالتكلفة",
    "BOQ": "بجدول الكميات"
  },
  "progressMethodName": {
    "MANUAL": "تحديثات الإنجاز",
    "TASKS": "المهام",
    "MILESTONES": "المعالم الرئيسية",
    "COST_TO_COST": "التكلفة",
    "BOQ": "جدول الكميات"
  },
  "progressMethodHint": {
    "MANUAL": "يسجل المدير نسبة إنجاز مؤرخة لكل جزء من الخطة، ويُحسب إنجاز المشروع بجمعها حسب أوزانها.",
    "TASKS": "نسبة مهام المشروع المكتملة، موزونة بتقديراتها.",
    "MILESTONES": "نسبة المعالم الرئيسية المتحققة، موزونة بأوزانها في الخطة.",
    "COST_TO_COST": "التكلفة حتى تاريخه مقارنةً بالموازنة المعتمدة، دون الفئات المستثناة من الإنجاز؛ بحد أقصى 100%.",
    "BOQ": "الكميات المعتمدة مقارنةً بجدول الكميات (تأتي مع وظائف المقاولات)."
  },
  "nodeKind": {
    "PHASE": "مرحلة",
    "WORK_PACKAGE": "حزمة عمل",
    "MILESTONE": "معلم رئيسي"
  },
  "memberRole": {
    "MANAGER": "مدير",
    "MEMBER": "عضو",
    "MANAGERBody": "يدير هذا المشروع: يعدّله ويعدّل خطته وفريقه.",
    "MEMBERBody": "يطّلع على المشروع ويضيف الملاحظات والملفات ويعمل على مهامه."
  },
  "progress": {
    "label": "الإنجاز",
    "valueText": "منجز بنسبة {{percent}}"
  },
  "marks": {
    "overdue": "متأخر",
    "dates": "{{start}} – {{end}}",
    "from": "من {{start}}",
    "pastEnd": "تجاوز تاريخ انتهائه",
    "late": "متأخر"
  },
  "errors": {
    "PROJECT_ILLEGAL_MOVE": "لا يمكن نقل المشروع إلى هذه الحالة من حالته الحالية. أعد تحميله لترى حالته الحالية.",
    "PROJECT_CLOSE_BLOCKED": "ما زال في المشروع ما ينتظر الإنجاز (موازنة بانتظار الاعتماد أو مشتريات مسودة مرتبطة به أو بنود فوترة لم تُفوتر ولم تُلغَ أو وقت بانتظار الاعتماد). أنهِه ثم أغلق المشروع.",
    "PROJECT_NOT_OPEN": "المشاريع المغلقة والملغاة لا تقبل أعمالًا أو مستندات جديدة. أعد فتح المشروع أولًا.",
    "PROJECT_FEATURE_OFF": "هذه الوظيفة موقوفة لهذا المشروع أو في الإعدادات › المشاريع.",
    "PROJECT_FEATURE_DEPENDENCY": "إحدى الوظائف التي فعّلتها تحتاج إلى وظيفة أخرى موقوفة. فعّل تلك الوظيفة أيضًا.",
    "PROJECTS_MODULE_OFF": "وحدة المشاريع موقوفة لشركتك.",
    "PROJECT_CUSTOMER_REQUIRED": "المشروع المنفذ لعميل يحتاج إلى عميله، والمشروع الداخلي ليس له عميل.",
    "PROJECT_CUSTOMER_MISMATCH": "عميل هذا المستند ليس عميل المشروع.",
    "PROJECT_MANAGER_INACTIVE": "يجب أن يكون المدير مستخدمًا نشطًا. اختر شخصًا حسابه مفعّل.",
    "PROJECT_MANAGER_MEMBERSHIP": "يبقى مدير المشروع في الفريق بصفة مدير. غيّر المدير أولًا.",
    "PROJECT_TYPE_ARCHIVED": "نوع المشروع هذا مؤرشف. استعِده من الإعدادات › أنواع المشاريع أو اختر نوعًا آخر.",
    "PROJECT_TYPE_CODE_TAKEN": "هذا الرمز مستخدم لنوع مشروع آخر. اختر رمزًا مختلفًا.",
    "PROJECT_PROGRESS_METHOD_UNAVAILABLE": "طريقة قياس الإنجاز هذه غير متاحة بعد، أو تحتاج إلى وظيفة موقوفة.",
    "PROJECT_NODE_CYCLE": "لا يمكن وضع جزء من الخطة تحت أحد أجزائه.",
    "PROJECT_MILESTONE_LEAF": "لا يمكن أن يكون تحت المعلم الرئيسي أجزاء. حوّله إلى مرحلة أو حزمة عمل أولًا.",
    "PROJECT_NODE_LIMIT": "تتسع الخطة لألفي صف على الأكثر. اجمع الأعمال في صفوف أقل.",
    "PROJECT_NODE_NOT_IN_PROJECT": "هذا الصف لم يعد في خطة هذا المشروع. أعد تحميل الخطة.",
    "PROJECT_NOT_A_MILESTONE": "المعالم الرئيسية وحدها تُسجَّل متحققة.",
    "PROJECT_PLAN_NOT_EMPTY": "لا يُطبَّق القالب إلا على خطة فارغة.",
    "PROJECT_TASK_NOT_LINKED": "هذه المهمة غير مرتبطة بهذا المشروع. اربطها به أولًا.",
    "PROJECT_TASK_ONE_PROJECT": "ترتبط المهمة بمشروع واحد على الأكثر. افصلها عن المشروع الآخر أولًا.",
    "PROJECT_OPEN_MILESTONES": "حقّق المعالم الرئيسية المفتوحة أو احذفها أولًا.",
    "PROJECT_SERIAL_GOODS": "لا يمكن توريد البضائع ذات الأرقام التسلسلية مباشرة إلى الموقع. استلمها في المخزون ثم اصرفها للمشروع.",
    "PROJECT_BUDGET_OPEN": "لهذا المشروع موازنة قيد الإعداد أو بانتظار الاعتماد. افتح ذلك الإصدار بدلًا من ذلك.",
    "PROJECT_BUDGET_ILLEGAL_MOVE": "لا يمكن لهذا الإصدار من الموازنة تنفيذ ذلك من حالته الحالية. أعد تحميله لترى حالته الآن.",
    "PROJECT_BUDGET_REASON_REQUIRED": "اذكر سبب تغيير الموازنة: السبب مطلوب ابتداءً من الإصدار الثاني.",
    "APPROVAL_REQUIRED": "اعتماد الموازنة مفعّل لهذا المشروع: قدّم الموازنة للاعتماد بدلًا من ذلك.",
    "APPROVAL_PENDING": "يتولى مسار اعتماد البتّ في هذه الموازنة، وتُعتمد من «موافقاتي».",
    "SELF_APPROVAL": "أنت من أعدّ هذه الموازنة أو قدّمها، لذا يعتمدها شخص آخر لديه صلاحية اعتماد الموازنات.",
    "PROJECT_COST_CATEGORY_CODE_TAKEN": "هذا الرمز مستخدم لفئة تكلفة أخرى. اختر رمزًا مختلفًا.",
    "PROJECT_COST_ENTRY_UNBALANCED": "يجب أن يكون مجموع سطور النقل صفرًا. اجعل المخصوم مساويًا للمضاف.",
    "closeBlockers": {
      "lead": "أنهِ ما يلي قبل إغلاق المشروع.",
      "PENDING_BUDGET": "موازنة بانتظار الاعتماد: اعتمدها أو اسحبها.",
      "OPEN_COMMITMENTS": "مشتريات مسودة مرتبطة به: {{count}}. رحّلها أو ألغِها أو افصلها عن المشروع.",
      "OPEN_BILLING_ITEMS": "بنود فوترة لم تُفوتر ولم تُلغَ: {{count}}. فوترها أو ألغِها.",
      "SUBMITTED_TIME": "سجلات وقت بانتظار الاعتماد: {{count}}. اعتمدها أو أرجِعها من «اعتماد الوقت»."
    }
  },
  "blocked": {
    "NOT_PERMITTED": "لا يمكنك تنفيذ هذا الإجراء على هذا المشروع.",
    "ILLEGAL_MOVE": "غير ممكن من الحالة الحالية للمشروع.",
    "NO_START_DATE": "حدد تاريخ البداية أولًا.",
    "OPEN_MILESTONES": "حقّق المعالم الرئيسية المفتوحة أو احذفها أولًا.",
    "FEATURE_OFF": "هذه الوظيفة موقوفة لهذا المشروع.",
    "PENDING_WORK": "توجد موازنة بانتظار الاعتماد أو مشتريات مسودة ما زالت مرتبطة بهذا المشروع أو بنود فوترة لم تُفوتر ولم تُلغَ أو وقت بانتظار الاعتماد. أنهِها أولًا."
  },
  "actions": {
    "new": "مشروع جديد",
    "export": "تصدير",
    "edit": "تعديل",
    "functions": "الوظائف",
    "history": "السجل",
    "activate": "تفعيل",
    "hold": "إيقاف مؤقت",
    "resume": "استئناف",
    "complete": "إكمال المشروع",
    "close": "إغلاق المشروع",
    "reopen": "إعادة فتح المشروع",
    "cancel": "إلغاء المشروع"
  },
  "lifecycle": {
    "reason": "السبب",
    "reasonRequired": "اذكر السبب.",
    "becomes": "يصبح",
    "keep": "الإبقاء على المشروع",
    "actualStart": "البداية الفعلية",
    "actualFinish": "النهاية الفعلية",
    "dateHint": "اليوم، ما لم يبدأ العمل أو ينتهِ في يوم آخر.",
    "activate": {
      "title": "تفعيل {{code}}؟",
      "body": "يبدأ العمل: يسجل الفريق الإنجاز والمهام على المشروع.",
      "confirm": "تفعيل المشروع",
      "toast": "فُعّل {{code}}"
    },
    "hold": {
      "title": "إيقاف {{code}} مؤقتًا؟",
      "body": "يتوقف العمل حتى يستأنفه أحد. يُحفظ السبب في سجل المشروع.",
      "confirm": "إيقاف مؤقت",
      "toast": "أُوقف {{code}} مؤقتًا"
    },
    "resume": {
      "title": "استئناف {{code}}؟",
      "body": "يعود المشروع نشطًا.",
      "confirm": "استئناف المشروع",
      "toast": "استُؤنف {{code}}"
    },
    "complete": {
      "title": "إكمال {{code}}؟",
      "body": "انتهى العمل، ويمكن تسجيل المستندات حتى يُغلق المشروع.",
      "confirm": "إكمال المشروع",
      "toast": "اكتمل {{code}}"
    },
    "close": {
      "title": "إغلاق {{code}}؟",
      "body": "لا يقبل المشروع المغلق مستندات أو أعمالًا جديدة، ولا يغيّر ذلك إلا إعادة فتحه.",
      "confirm": "إغلاق المشروع",
      "toast": "أُغلق {{code}}"
    },
    "reopen": {
      "title": "إعادة فتح {{code}}؟",
      "body": "يعود المشروع نشطًا. يُحفظ السبب في سجل المشروع.",
      "confirm": "إعادة فتح المشروع",
      "toast": "أُعيد فتح {{code}}"
    },
    "cancel": {
      "title": "إلغاء {{code}}؟",
      "body": "لا يمكن إعادة فتح المشروع الملغى، وتعود مهامه إلى فرقها.",
      "confirm": "إلغاء المشروع",
      "toast": "أُلغي {{code}}"
    }
  },
  "people": {
    "inactive": "غير نشط",
    "error": "تعذر تحميل الأشخاص. حاول مرة أخرى.",
    "placeholder": "اختر شخصًا",
    "search": "ابحث عن شخص…",
    "empty": "لا يوجد من يطابق البحث."
  },
  "site": {
    "placeholder": "اختر الموقع",
    "search": "ابحث عن موقع…",
    "none": "لا توجد مواقع بعد. أضفها من الإعدادات › مواقع العمل."
  },
  "columns": {
    "code": "الرمز",
    "name": "المشروع",
    "manager": "المدير",
    "status": "الحالة",
    "progress": "الإنجاز",
    "nextMilestone": "المعلم الرئيسي التالي",
    "start": "البداية",
    "end": "النهاية",
    "type": "النوع",
    "unit": "الوحدة",
    "contractValue": "قيمة العقد",
    "health": "سلامة المشروع"
  },
  "fields": {
    "type": "نوع المشروع",
    "kind": "الفئة",
    "name": "الاسم",
    "nameAr": "الاسم بالعربية",
    "customer": "العميل",
    "manager": "المدير",
    "startDate": "البداية",
    "endDate": "النهاية",
    "contractValue": "قيمة العقد",
    "orgUnit": "الوحدة",
    "site": "الموقع",
    "priority": "الأولوية",
    "contractReference": "مرجع العقد أو أمر الشراء",
    "description": "الوصف",
    "billingMethod": "طريقة الفوترة",
    "progressMethod": "قياس الإنجاز"
  },
  "filters": {
    "status": "الحالة",
    "anyStatus": "كل الحالات",
    "type": "نوع المشروع",
    "anyType": "كل الأنواع",
    "manager": "المدير",
    "anyManager": "كل المديرين",
    "managedByMe": "التي أديرها",
    "customer": "العميل",
    "anyCustomer": "كل العملاء",
    "unit": "الوحدة",
    "anyUnit": "كل الوحدات",
    "chosenPerson": "الشخص المختار",
    "chosenCustomer": "العميل المختار",
    "health": "سلامة المشروع",
    "anyHealth": "كل مستويات السلامة",
    "signal": "التنبيه",
    "anySignal": "كل التنبيهات"
  },
  "portfolio": {
    "title": "المشاريع",
    "views": "عروض المشاريع",
    "view": {
      "mine": "مشاريعي",
      "active": "النشطة",
      "attention": "تحتاج إلى متابعة",
      "all": "الكل",
      "closed": "المنتهية"
    },
    "searchPlaceholder": "ابحث بالرمز أو الاسم أو العميل…",
    "searchLabel": "البحث في المشاريع",
    "clearSearch": "مسح البحث",
    "clearFilters": "مسح عوامل التصفية",
    "filters": "التصفية",
    "filtersCount_zero": "التصفية، لا شيء مفعّل",
    "filtersCount_one": "التصفية، عامل واحد مفعّل",
    "filtersCount_two": "التصفية، عاملان مفعّلان",
    "filtersCount_few": "التصفية، {{n}} عوامل مفعّلة",
    "filtersCount_many": "التصفية، {{n}} عاملًا مفعّلًا",
    "filtersCount_other": "التصفية، {{n}} عامل مفعّل",
    "layout": {
      "label": "طريقة العرض",
      "list": "قائمة",
      "board": "لوحة",
      "timeline": "مخطط زمني"
    },
    "figures": "أرقام المشاريع",
    "activeContractValue": "العقود النشطة",
    "activeContractSub_zero": "لا توجد مشاريع نشطة",
    "activeContractSub_one": "مشروع نشط واحد",
    "activeContractSub_two": "مشروعان نشطان",
    "activeContractSub_few": "{{n}} مشاريع نشطة",
    "activeContractSub_many": "{{n}} مشروعًا نشطًا",
    "activeContractSub_other": "{{n}} مشروع نشط",
    "tableLabel": "المشاريع",
    "exported": "صُدّرت المشاريع",
    "empty": {
      "filteredTitle": "لا توجد مشاريع تطابق عوامل التصفية هذه.",
      "filteredBody": "امسح أحد عوامل التصفية أو ابحث عن شيء آخر.",
      "view": {
        "mine": "لست عضوًا في أي مشروع مفتوح.",
        "active": "لا توجد مشاريع قيد التخطيط أو نشطة أو متوقفة مؤقتًا.",
        "attention": "لا شيء يحتاج إلى متابعة: لا مشروع عليه تحذير أو تنبيه حرج.",
        "all": "لا توجد مشاريع بعد.",
        "closed": "لا توجد مشاريع مكتملة أو مغلقة أو ملغاة بعد."
      }
    },
    "first": {
      "title": "ابدأ مشروعك الأول",
      "body": "يجمع المشروع خطته وفريقه ومهامه وملفاته في مكان واحد. اختر طريقة البدء، ويمكنك تغيير كل شيء لاحقًا.",
      "titleReader": "لا توجد مشاريع بعد.",
      "bodyReader": "تظهر المشاريع هنا عندما يبدأ أحد مشروعًا.",
      "blank": "مشروع فارغ",
      "blankBody": "سمِّه واختر العميل والتواريخ، ثم ابنِ الخطة بنفسك.",
      "type": "من نوع مشروع",
      "typeBody": "ابدأ من نوع قياسي (مقاولات أو تجهيزات داخلية أو خدمة) مع خطته مؤرخة من تاريخ البداية.",
      "quotation": "من عرض سعر معتمد",
      "quotationBody": "يأتي مع الفوترة: يملأ عميل عرض السعر وقيمته وبنوده بيانات المشروع."
    },
    "strip": {
      "billed": "المفوتر",
      "costToDate": "التكلفة حتى الآن",
      "forecastMargin": "هامش الربح المتوقع",
      "forecastMarginSub": "المشاريع المُقاسة",
      "unbilled": "غير المفوتر",
      "retentionHeld": "المحتجزات لدى العملاء"
    },
    "health": {
      "asOf": "سلامة المشاريع حتى {{time}}",
      "notYet": "لم تُفحص سلامة المشاريع بعد",
      "refresh": "تحديث",
      "refreshing": "جارٍ التحديث…",
      "refreshLabel": "تحديث سلامة المشاريع الآن",
      "queued": "طُلب تحديث سلامة المشاريع، وستتحدث الأرقام خلال دقائق."
    },
    "figuresToggle": "الأرقام",
    "stripScope": "تشمل هذه الأرقام كل مشروع نشط يمكنك رؤيته، أيًّا كان التبويب أو عوامل التصفية."
  },
  "board": {
    "label": "المشاريع حسب الحالة",
    "column": "مشاريع بحالة {{status}}",
    "dragHint": "اسحب البطاقة إلى عمود آخر لتغيير حالتها، وتؤكد قبل أن يتغير شيء.",
    "empty": "لا شيء",
    "moveTo": "نقل {{code}} إلى…",
    "refused": "لا يمكن نقل {{code}} من «{{from}}» إلى «{{to}}».",
    "ends": "ينتهي في {{date}}",
    "more": "يُعرض {{shown}} من {{total}}. صفِّ النتائج لترى البقية."
  },
  "timeline": {
    "label": "المشاريع على مخطط زمني",
    "groupBy": "التجميع حسب",
    "group": {
      "none": "بلا تجميع",
      "manager": "المدير",
      "customer": "العميل"
    },
    "empty": "لا توجد مشاريع في هذه الفترة.",
    "lateLegend": "متأخر",
    "legendJoin": "، "
  },
  "new": {
    "title": "مشروع جديد",
    "description": "يبدأ بحالة «قيد التخطيط»، وتفعّله عند بدء العمل.",
    "discardTitle": "تجاهل هذا المشروع الجديد؟",
    "discardBody": "ستضيع البيانات التي أدخلتها.",
    "discard": "تجاهل",
    "keepEditing": "متابعة التعديل",
    "start": "البدء من",
    "modes": {
      "blank": "مشروع فارغ",
      "blankBody": "خطة فارغة تبنيها بنفسك.",
      "type": "نوع مشروع",
      "typeBody": "وظائفه وطريقة فوترته وقالب خطته.",
      "quotation": "عرض سعر",
      "quotationBody": "عرض سعر معتمد: عميله وقيمته وبنوده.",
      "quotationOff": "يتطلب المبيعات وصلاحية قراءة عروض الأسعار."
    },
    "namePlaceholder": "مثال: تجهيز فيلا الخوض",
    "managerHint": "أنت، ما لم يكن شخص آخر يديره.",
    "contractHint": "القيمة الأصلية المتفق عليها قبل أي أوامر تغييرية.",
    "planPreview": "الخطة من القالب",
    "applyTemplate": "إنشاء هذه الصفوف",
    "noTemplate": "ليس لهذا النوع قالب خطة.",
    "emptyPlan": "يبدأ المشروع بخطة فارغة.",
    "previewHint": "مؤرخة بأيام العمل من تاريخ البداية، دون عطل نهاية الأسبوع والعطل الرسمية.",
    "moreDetails": "تفاصيل أخرى",
    "unitHint": "وحدتك، ما لم تختر وحدة أخرى.",
    "noUnit": "بلا وحدة",
    "siteHint": "مكان تنفيذ العمل.",
    "noSite": "بلا موقع",
    "save": "إنشاء المشروع",
    "created": "أُنشئ {{code}}",
    "errors": {
      "type": "اختر نوع المشروع.",
      "name": "أدخل اسم المشروع.",
      "customer": "اختر العميل.",
      "start": "أدخل تاريخ البداية.",
      "end": "تاريخ النهاية قبل تاريخ البداية."
    }
  },
  "workspace": {
    "title": "المشروع",
    "backToPortfolio": "العودة إلى المشاريع",
    "managedBy": "يديره {{name}}",
    "workingDaysLeft_zero": "لم يبقَ أي يوم عمل",
    "workingDaysLeft_one": "بقي يوم عمل واحد",
    "workingDaysLeft_two": "بقي يوما عمل",
    "workingDaysLeft_few": "بقيت {{n}} أيام عمل",
    "workingDaysLeft_many": "بقي {{n}} يوم عمل",
    "workingDaysLeft_other": "بقي {{n}} يوم عمل",
    "pastEnd": "تجاوز تاريخ انتهائه",
    "statusAlert": {
      "CANCELLED": "أُلغي في {{date}}",
      "ON_HOLD": "متوقف مؤقتًا منذ {{date}}"
    },
    "planOff": "الخطة موقوفة لهذا المشروع (الوظائف في قائمة المزيد).",
    "moneyHidden": "تحتاج إلى صلاحية للاطلاع على أموال المشروع."
  },
  "tabs": {
    "label": "أقسام المشروع",
    "overview": "نظرة عامة",
    "plan": "الخطة",
    "tasks": "المهام",
    "team": "الفريق",
    "files": "الملفات",
    "activity": "النشاط",
    "budget": "الموازنة والتكلفة"
  },
  "edit": {
    "title": "تعديل {{code}}",
    "save": "حفظ المشروع",
    "saved": "حُفظ {{code}}",
    "managerHint": "ينضم المدير الجديد إلى الفريق بصفة مدير.",
    "billingLocked": "تثبت بعد تفعيل المشروع."
  },
  "functions": {
    "title": "وظائف هذا المشروع",
    "body": "أوقف ما لا يستخدمه هذا المشروع، فتختفي تبويباته وإجراءاته.",
    "save": "حفظ الوظائف",
    "saved": "حُفظت الوظائف",
    "companyOff": "موقوفة للشركة كلها في الإعدادات › المشاريع.",
    "approverOnly": "لا يغيّر اعتماد الموازنة إلا من يملك صلاحية اعتماد الموازنات."
  },
  "overview": {
    "attention": {
      "title": "تحتاج إلى متابعة",
      "none": "لا شيء يحتاج إلى متابعة.",
      "overdueMilestones_zero": "لا معالم رئيسية متأخرة",
      "overdueMilestones_one": "معلم رئيسي متأخر",
      "overdueMilestones_two": "معلمان رئيسيان متأخران",
      "overdueMilestones_few": "معالم رئيسية متأخرة",
      "overdueMilestones_many": "معلمًا رئيسيًا متأخرًا",
      "overdueMilestones_other": "معلم رئيسي متأخر",
      "overdueReason_zero": "لا شيء تجاوز موعد استحقاقه.",
      "overdueReason_one": "تجاوز موعد استحقاقه ولم يتحقق.",
      "overdueReason_two": "تجاوزا موعد استحقاقهما ولم يتحققا.",
      "overdueReason_few": "تجاوزت موعد استحقاقها ولم تتحقق.",
      "overdueReason_many": "تجاوزت موعد استحقاقها ولم تتحقق.",
      "overdueReason_other": "تجاوزت موعد استحقاقها ولم تتحقق.",
      "pastEnd": "تجاوز تاريخ انتهائه",
      "pastEndReason_zero": "كان موعد انتهائه اليوم، {{date}}. غيّر تاريخ النهاية أو أكمل المشروع.",
      "pastEndReason_one": "كان موعد انتهائه {{date}}، قبل يوم واحد. غيّر تاريخ النهاية أو أكمل المشروع.",
      "pastEndReason_two": "كان موعد انتهائه {{date}}، قبل يومين. غيّر تاريخ النهاية أو أكمل المشروع.",
      "pastEndReason_few": "كان موعد انتهائه {{date}}، قبل {{days}} أيام. غيّر تاريخ النهاية أو أكمل المشروع.",
      "pastEndReason_many": "كان موعد انتهائه {{date}}، قبل {{days}} يومًا. غيّر تاريخ النهاية أو أكمل المشروع.",
      "pastEndReason_other": "كان موعد انتهائه {{date}}، قبل {{days}} يوم. غيّر تاريخ النهاية أو أكمل المشروع.",
      "notActivated": "ما زال قيد التخطيط",
      "notActivatedReason": "كان موعد بدايته {{date}}. فعّله أو غيّر تاريخ البداية.",
      "overdueTasks_zero": "لا مهام متأخرة",
      "overdueTasks_one": "مهمة متأخرة",
      "overdueTasks_two": "مهمتان متأخرتان",
      "overdueTasks_few": "مهام متأخرة",
      "overdueTasks_many": "مهمة متأخرة",
      "overdueTasks_other": "مهمة متأخرة",
      "overdueTasksReason_zero": "لا شيء تجاوز موعد استحقاقه.",
      "overdueTasksReason_one": "مفتوحة وتجاوزت موعد استحقاقها.",
      "overdueTasksReason_two": "مفتوحتان وتجاوزتا موعد استحقاقهما.",
      "overdueTasksReason_few": "مفتوحة وتجاوزت موعد استحقاقها.",
      "overdueTasksReason_many": "مفتوحة وتجاوزت موعد استحقاقها.",
      "overdueTasksReason_other": "مفتوحة وتجاوزت موعد استحقاقها.",
      "failed": "تعذّر تحميل مؤشرات المشروع، فقد تنقص هذه القائمة بعض التنبيهات.",
      "retry": "إعادة المحاولة"
    },
    "progress": {
      "title": "الإنجاز",
      "method": "يُقاس {{method}}",
      "how": "كيف يُحسب؟"
    },
    "milestones": {
      "title": "المعالم الرئيسية القادمة",
      "openPlan": "فتح الخطة",
      "none": "لا توجد معالم رئيسية مفتوحة.",
      "late_zero": "في موعده",
      "late_one": "متأخر يومًا واحدًا",
      "late_two": "متأخر يومين",
      "late_few": "متأخر {{n}} أيام",
      "late_many": "متأخر {{n}} يومًا",
      "late_other": "متأخر {{n}} يوم"
    },
    "notes": {
      "title": "الملاحظات المثبتة",
      "all": "كل الملاحظات",
      "none": "لا توجد ملاحظات مثبتة.",
      "by": "{{name}} · {{date}}"
    },
    "details": "التفاصيل",
    "noType": "بلا نوع",
    "planned": "المخطط",
    "actual": "الفعلي",
    "created": "الإنشاء",
    "createdBy": "{{date}} بواسطة {{name}}",
    "team": "الفريق",
    "teamAll_zero": "لا أحد",
    "teamAll_one": "شخص واحد",
    "teamAll_two": "شخصان",
    "teamAll_few": "الأشخاص الـ{{n}}",
    "teamAll_many": "الأشخاص الـ{{n}}",
    "teamAll_other": "الأشخاص الـ{{n}}",
    "trail": "المستندات",
    "quotation": "عرض سعر",
    "projectSlip": "مشروع",
    "closedNote": {
      "COMPLETED": "انتهى العمل. أغلق المشروع عندما لا يبقى ما يُسجَّل.",
      "CLOSED": "مغلق: لا مستندات ولا أعمال جديدة. أعد فتحه لتسجيل المزيد.",
      "CANCELLED": "ملغى: محفوظ لسجله."
    }
  },
  "plan": {
    "unavailable": "تعذر تحميل الخطة.",
    "add": {
      "PHASE": "إضافة مرحلة",
      "WORK_PACKAGE": "إضافة حزمة عمل",
      "MILESTONE": "إضافة معلم رئيسي"
    },
    "addSave": "إضافة إلى الخطة",
    "save": "حفظ",
    "toast": {
      "saved": "حُفظ «{{name}}»",
      "added": "أُضيف «{{name}}» إلى الخطة",
      "achieved": "تحقق «{{name}}»",
      "unachieved": "أُلغي تحقق «{{name}}»",
      "progress": "«{{name}}» منجز بنسبة {{percent}}٪",
      "removed": "أُزيل «{{name}}» من الخطة",
      "rescheduled": "أُعيدت جدولة «{{name}}»",
      "template": "أُنشئت الخطة من القالب",
      "moved": {
        "up": "نُقل «{{name}}» إلى الأعلى",
        "down": "نُقل «{{name}}» إلى الأسفل",
        "indent": "نُقل «{{name}}» تحت الصف الذي فوقه",
        "outdent": "رُفع «{{name}}» مستوى واحدًا"
      }
    },
    "menu": {
      "label": "إجراءات «{{name}}»",
      "addWorkPackage": "إضافة حزمة عمل تحته",
      "addMilestone": "إضافة معلم رئيسي تحته",
      "up": "نقل إلى الأعلى",
      "down": "نقل إلى الأسفل",
      "indent": "نقل تحت الصف الذي فوقه",
      "outdent": "رفع مستوى واحد",
      "open": "فتح"
    },
    "achieve": "تسجيل التحقق",
    "unachieve": "إلغاء التحقق",
    "updateProgress": "تحديث الإنجاز",
    "columns": {
      "name": "الخطة",
      "start": "البداية",
      "finish": "النهاية",
      "days": "أيام العمل",
      "weight": "الوزن",
      "progress": "الإنجاز",
      "tasks": "المهام المفتوحة",
      "actions": "الإجراءات"
    },
    "achievedOn": "تحقق في {{date}}",
    "overdue": "متأخر",
    "late": "متأخر",
    "legend": {
      "planned": "مخطط",
      "late": "متأخر"
    },
    "open": "مفتوح",
    "viewLabel": "عرض الخطة",
    "view": {
      "table": "جدول",
      "timeline": "مخطط زمني"
    },
    "applyTemplate": "تطبيق القالب",
    "applyBody": "تُنشأ هذه الصفوف بتواريخ محسوبة بأيام العمل من تاريخ البداية {{date}}.",
    "applyConfirm": "إنشاء الخطة",
    "empty": {
      "title": "لا توجد خطة بعد",
      "body": "طبّق قالب النوع أو أضف المرحلة الأولى.",
      "reader": "لم يخطط مدير المشروع له بعد."
    },
    "timelineHint": "اسحب شريطًا أو معينًا لاقتراح تواريخ جديدة (أو Alt مع مفتاح سهم)، وتؤكد قبل أن يتحرك شيء.",
    "timelineLabel": "خطة {{code}} على مخطط زمني",
    "keysHint": "على الصف: Alt مع ↑/↓ لإعادة الترتيب، وAlt مع ← لنقله تحت الصف الذي فوقه، وAlt مع → لرفعه مستوى، وEnter لفتحه.",
    "tableLabel": "خطة {{code}}",
    "moveTitle": "نقل «{{name}}» بمقدار {{days}} يوم عمل؟",
    "moveBody": "التواريخ الجديدة: {{start}} – {{end}}. تبقى تواريخ المعالم الرئيسية التي بعده كما هي.",
    "moveBodyMilestone": "تاريخ الاستحقاق الجديد: {{date}}.",
    "moveConfirm": "نقل",
    "inline": {
      "label": "إضافة صف إلى الخطة",
      "name": "اسم الصف الجديد",
      "placeholder": "الاسم ثم Enter",
      "add": "إضافة"
    },
    "fields": {
      "kind": "النوع",
      "parent": "تحت",
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "start": "البداية المخططة",
      "finish": "النهاية المخططة",
      "due": "الاستحقاق",
      "weight": "الوزن",
      "outline": "الترقيم",
      "openTasks": "المهام المفتوحة"
    },
    "topLevel": "المستوى الأعلى",
    "errors": {
      "name": "أدخل الاسم.",
      "finish": "تاريخ النهاية قبل تاريخ البداية.",
      "weight": "أدخل عددًا صحيحًا من 0 إلى 1000.",
      "percent": "أدخل نسبة من 0 إلى 100."
    },
    "hints": {
      "kindWithChildren": "الصف الذي تحته صفوف لا يمكن أن يصبح معلمًا رئيسيًا.",
      "weight": "مقدار ما يُحسب به في إنجاز المشروع."
    },
    "workingDays_zero": "لا أيام عمل",
    "workingDays_one": "يوم عمل واحد",
    "workingDays_two": "يوما عمل",
    "workingDays_few": "{{count}} أيام عمل",
    "workingDays_many": "{{count}} يوم عمل",
    "workingDays_other": "{{count}} يوم عمل",
    "acceptance": "القبول",
    "unachieveReason": "لماذا يُلغى التحقق؟",
    "achievedOnLabel": "تاريخ التحقق",
    "achieveNote": "ملاحظة",
    "achieveNoteHint": "مرجع العميل أو من قَبِل العمل.",
    "progressTitle": "الإنجاز",
    "percent": "نسبة الإنجاز",
    "asOf": "حتى تاريخ",
    "progressNote": "ملاحظة",
    "saveProgress": "حفظ الإنجاز",
    "history": "سجل الإنجاز",
    "historyLine": "حتى {{date}} · {{name}}",
    "noHistory": "لم يُسجَّل أي إنجاز بعد.",
    "remove": "إزالة من الخطة",
    "removeTitle": "إزالة «{{name}}»؟",
    "removeBody": "يخرج من الخطة، ويبقى سجله في النشاط.",
    "removeBodyChildren": "تُزال الصفوف التي تحته أيضًا، ويبقى سجلها في النشاط."
  },
  "tasks": {
    "new": "مهمة جديدة",
    "layout": "طريقة عرض المهام",
    "list": "قائمة",
    "board": "لوحة",
    "tableLabel": "مهام {{code}}",
    "place": "وضع في الخطة…",
    "rowActions": "إجراءات {{number}}",
    "empty": "لا توجد مهام لهذا المشروع بعد.",
    "emptyBody": "أضف المهمة الأولى، وستُربط بهذا المشروع.",
    "placed": "وُضعت {{number}} في الخطة",
    "placeTitle": "وضع {{number}} في الخطة",
    "placeConfirm": "وضع المهمة",
    "node": "جزء الخطة",
    "nodeHint": "تُحسب مهامها المفتوحة على ذلك الصف، وكذلك نسبة إنجازه عند قياس الإنجاز بالمهام.",
    "nowhere": "لا جزء محدد",
    "groupByNode": "تجميع حسب جزء الخطة",
    "groupLabel": "مهام {{node}} في {{code}}",
    "groupCount_zero": "{{count}} مهمة",
    "groupCount_one": "مهمة واحدة",
    "groupCount_two": "مهمتان",
    "groupCount_few": "{{count}} مهام",
    "groupCount_many": "{{count}} مهمة",
    "groupCount_other": "{{count}} مهمة",
    "notInPlan": "خارج الخطة",
    "groupCapped": "يشمل التجميع أول {{shown}} من {{total}} مهمة. اعرض القائمة لرؤية البقية.",
    "currentNode": "موضعها الحالي: {{node}}.",
    "currentNowhere": "ليست في الخطة بعد."
  },
  "team": {
    "add": "إضافة عضو",
    "tableLabel": "فريق {{code}}",
    "columns": {
      "person": "الشخص",
      "access": "الصلاحية",
      "role": "الدور في المشروع",
      "added": "تاريخ الإضافة",
      "actions": "الإجراءات"
    },
    "projectManager": "مدير المشروع",
    "addedBy": "{{date}} بواسطة {{name}}",
    "edit": "تعديل {{name}}",
    "remove": "إزالة {{name}}",
    "removeTitle": "إزالة {{name}} من الفريق؟",
    "removeBody": "لن يرى مهام المشروع المشتركة مع فريقه. تبقى مهامه المفتوحة مسندة إليه، ويمكن إعادة إسنادها من المهام.",
    "removeConfirm": "إزالة من الفريق",
    "removed": "أُزيل {{name}} من الفريق",
    "errors": {
      "person": "اختر شخصًا."
    },
    "saved": "حُدّثت بيانات {{name}}",
    "added": "أُضيف {{name}} إلى الفريق",
    "editTitle": "{{name}} في هذا المشروع",
    "addTitle": "إضافة عضو إلى الفريق",
    "save": "حفظ",
    "addConfirm": "إضافة إلى الفريق",
    "person": "الشخص",
    "access": "الصلاحية",
    "managerFixed": "مدير المشروع مدير هنا دائمًا.",
    "roleTitle": "الدور في المشروع",
    "roleTitleHint": "مثال: مهندس موقع، مهندس كميات."
  },
  "notes": {
    "title": "الملاحظات",
    "new": "ملاحظة جديدة",
    "placeholder": "اكتب ملاحظة للفريق…",
    "add": "إضافة ملاحظة",
    "added": "أُضيفت الملاحظة",
    "none": "لا توجد ملاحظات بعد.",
    "pinned": "مثبتة",
    "pin": "تثبيت الملاحظة",
    "unpin": "إلغاء تثبيت الملاحظة",
    "remove": "إزالة الملاحظة",
    "removeTitle": "إزالة هذه الملاحظة؟",
    "removeBody": "تختفي من المشروع، وتُحفظ الإزالة في سجله.",
    "errors": {
      "empty": "اكتب شيئًا أولًا."
    },
    "toast": {
      "pin": "ثُبّتت الملاحظة",
      "unpin": "أُلغي تثبيت الملاحظة",
      "remove": "أُزيلت الملاحظة"
    },
    "pinNamed": "تثبيت ملاحظة {{name}}، {{date}}",
    "unpinNamed": "إلغاء تثبيت ملاحظة {{name}}، {{date}}",
    "removeNamed": "إزالة ملاحظة {{name}}، {{date}}"
  },
  "activity": {
    "title": "النشاط",
    "none": "لم يحدث شيء بعد.",
    "newer": "الأحدث",
    "older": "الأقدم",
    "page": "الصفحة {{page}} من {{pages}}",
    "system": "سحاب",
    "other": "أجرى تغييرًا على {{entity}}",
    "entity": {
      "PROJECT": "المشروع",
      "MEMBER": "عضو الفريق",
      "NODE": "جزء الخطة",
      "NOTE": "الملاحظة",
      "FILE": "الملف"
    },
    "action": {
      "CREATE": "أنشأ {{entity}}",
      "UPDATE": "عدّل {{entity}}",
      "ACTIVATE": "فعّل المشروع",
      "HOLD": "أوقف المشروع مؤقتًا",
      "RESUME": "استأنف المشروع",
      "COMPLETE": "أكمل المشروع",
      "CLOSE": "أغلق المشروع",
      "REOPEN": "أعاد فتح المشروع",
      "CANCEL": "ألغى المشروع",
      "FEATURES": "غيّر وظائف المشروع",
      "ADD": "أضاف {{entity}}",
      "REMOVE": "أزال {{entity}}",
      "MOVE": "نقل {{entity}}",
      "ACHIEVE": "سجّل تحقق معلم رئيسي",
      "UNACHIEVE": "ألغى تحقق معلم رئيسي",
      "PROGRESS": "حدّث الإنجاز",
      "APPLY_TEMPLATE": "أنشأ الخطة من قالب",
      "PIN": "ثبّت ملاحظة",
      "UNPIN": "ألغى تثبيت ملاحظة",
      "ATTACH": "أرفق ملفًا",
      "DETACH": "أزال ملفًا",
      "UPDATE_FEATURES": "غيّر وظائف المشروع",
      "APPLY_PLAN": "أضاف خطة من المساعد",
      "ADD_MEMBER": "أضاف عضوًا إلى الفريق",
      "UPDATE_MEMBER": "غيّر صلاحية عضو في الفريق",
      "REMOVE_MEMBER": "أزال عضوًا من الفريق",
      "ADD_NOTE": "أضاف ملاحظة",
      "PIN_NOTE": "ثبّت ملاحظة",
      "UNPIN_NOTE": "ألغى تثبيت ملاحظة",
      "REMOVE_NOTE": "أزال ملاحظة",
      "ADD_NODE": "أضاف إلى الخطة",
      "UPDATE_NODE": "عدّل الخطة",
      "MOVE_NODE": "نقل جزءًا من الخطة",
      "REMOVE_NODE": "أزال جزءًا من الخطة",
      "ACHIEVE_MILESTONE": "سجّل تحقق معلم رئيسي",
      "UNACHIEVE_MILESTONE": "ألغى تحقق معلم رئيسي",
      "PLACE_TASK": "وضع مهمة في الخطة",
      "BUDGET_CREATE": "بدأ إصدارًا جديدًا من الموازنة",
      "BUDGET_UPDATE": "عدّل مسودة الموازنة",
      "BUDGET_DELETE": "حذف مسودة موازنة",
      "BUDGET_SUBMIT": "قدّم الموازنة للاعتماد",
      "BUDGET_APPROVE": "اعتمد الموازنة",
      "BUDGET_RETURN": "أعاد الموازنة",
      "BILL": "أصدر فاتورة",
      "BILL_VOID": "أبطل فاتورة",
      "BILLING_OVERRIDE": "عدّل سطرًا للفوترة",
      "EXPORT": "صدّر بيانات المشروع",
      "SIGNAL_ACKNOWLEDGE": "أقرّ بتنبيه",
      "SIGNAL_UNACKNOWLEDGE": "أعاد فتح تنبيه",
      "CONTRACT_CREATE": "بدأ العقد",
      "CONTRACT_UPDATE": "عدّل شروط العقد",
      "CONTRACT_ACTIVATE": "فعّل العقد",
      "CONTRACT_AMEND": "عدّل العقد بملحق",
      "CONTRACT_PRACTICAL_COMPLETION": "سجّل الاستلام الابتدائي",
      "CONTRACT_CLOSE": "أغلق الحساب الختامي",
      "CLAIM_CERTIFY": "اعتمد مستخلصًا",
      "CLAIM_VOID": "أبطل اعتماد مستخلص",
      "RETENTION_RELEASE": "أفرج عن محتجزات",
      "RETENTION_FORFEIT": "تنازل عن محتجزات"
    },
    "family": {
      "budget": "عدّل الموازنة",
      "billingPlan": "عدّل خطة الفوترة",
      "billing": "عدّل الفوترة",
      "claim": "عدّل مستخلصًا",
      "variation": "عدّل أمرًا تغييريًا",
      "guarantee": "عدّل ضمانًا",
      "boq": "عدّل جدول الكميات",
      "retention": "عدّل المحتجزات",
      "contract": "عدّل العقد",
      "signal": "عدّل تنبيهًا"
    }
  },
  "customerTab": {
    "title": "المشاريع",
    "count_zero": "لا توجد مشاريع",
    "count_one": "مشروع واحد",
    "count_two": "مشروعان",
    "count_few": "{{n}} مشاريع",
    "count_many": "{{n}} مشروعًا",
    "count_other": "{{n}} مشروع",
    "showAll": "عرض في المشاريع",
    "empty": "لا توجد مشاريع لهذا العميل بعد.",
    "emptyBody": "ابدأ مشروعًا، وسيُفتح وهذا العميل مختار."
  },
  "settings": {
    "defaults": "المشاريع الجديدة",
    "reload": "تحميل تغييراتهم",
    "conflict": "حفظ شخص آخر هذه الإعدادات في الأثناء. حمّل تغييراته ثم أعد تغييراتك.",
    "thresholds": {
      "title": "مستويات الموازنة",
      "body": "استخدام الموازنة هو التكلفة الفعلية والملتزم بها مقارنةً بالموازنة المعتمدة. عند هذه المستويات يتحول المشروع إلى الكهرماني ثم الأحمر، ويُبلَّغ مديره مرة واحدة لكل مستوى.",
      "warn": "التنبيه عند",
      "warnHint": "كهرماني، مع تنبيه للمدير.",
      "critical": "التجاوز عند",
      "criticalHint": "أحمر: عادةً 100%، أي الموازنة نفسها.",
      "order": "يجب أن يكون المستوى الحرج أعلى من مستوى التحذير.",
      "range": "أدخل نسبة مئوية صحيحة من 1 إلى 500."
    },
    "categoryDefaults": {
      "title": "فئة التكلفة عند عدم اختيار فئة",
      "body": "تُستخدم عندما يترك الموظف الفئة فارغة ولا تكون فئة المنتج ولا الحساب ولا فئة المصروف مربوطة (الإعدادات › فئات التكاليف).",
      "seeded": "الفئة القياسية ({{code}})",
      "source": {
        "goods": "البضائع المشتراة لمشروع",
        "services": "الخدمات المشتراة لمشروع",
        "expense": "المصروفات",
        "materialIssue": "المواد المصروفة من المخزون",
        "time": "الوقت",
        "salesCogs": "تكلفة البضاعة المباعة (مع الفوترة)"
      },
      "hint": {
        "goods": "سطور مشتريات المنتجات الموردة إلى الموقع.",
        "services": "سطور مشتريات الخدمات والنص الحر.",
        "expense": "المصروفات المرتبطة بمشروع.",
        "materialIssue": "المخزون المصروف لمشروع.",
        "time": "الساعات المعتمدة المسجلة على المشاريع.",
        "salesCogs": "تأتي مع فوترة المشاريع."
      }
    }
  },
  "types": {
    "placeholder": "اختر نوع المشروع",
    "search": "ابحث عن نوع…",
    "none": "لا توجد أنواع مشاريع. أضفها من الإعدادات › أنواع المشاريع.",
    "addPresets": "إضافة الأنواع القياسية",
    "presetsAdded_zero": "لم يُضف أي نوع قياسي",
    "presetsAdded_one": "أُضيف نوع قياسي واحد",
    "presetsAdded_two": "أُضيف نوعان قياسيان",
    "presetsAdded_few": "أُضيفت {{count}} أنواع قياسية",
    "presetsAdded_many": "أُضيف {{count}} نوعًا قياسيًا",
    "presetsAdded_other": "أُضيف {{count}} نوع قياسي",
    "presetsNone": "لديك كل الأنواع القياسية بالفعل",
    "new": "نوع جديد",
    "newTitle": "نوع مشروع جديد",
    "editTitle": "تعديل النوع {{code}}",
    "views": "عروض أنواع المشاريع",
    "active": "النشطة",
    "archived": "المؤرشفة",
    "archivedStamp": "مؤرشف",
    "listLabel": "أنواع المشاريع",
    "templateCount_zero": "لا صفوف في الخطة",
    "templateCount_one": "صف واحد في الخطة",
    "templateCount_two": "صفان في الخطة",
    "templateCount_few": "{{count}} صفوف في الخطة",
    "templateCount_many": "{{count}} صفًا في الخطة",
    "templateCount_other": "{{count}} صف في الخطة",
    "projectCount_zero": "لا مشاريع",
    "projectCount_one": "مشروع واحد",
    "projectCount_two": "مشروعان",
    "projectCount_few": "{{count}} مشاريع",
    "projectCount_many": "{{count}} مشروعًا",
    "projectCount_other": "{{count}} مشروع",
    "edit": "تعديل {{name}}",
    "archive": "أرشفة {{name}}",
    "restore": "استعادة {{name}}",
    "archiveTitle": "أرشفة {{name}}؟",
    "archiveBody": "لن يبدأ مشاريع جديدة، وتستمر المشاريع التي أُنشئت منه.",
    "archiveConfirm": "أرشفة النوع",
    "restoreTitle": "استعادة {{name}}؟",
    "restoreBody": "يمكنه بدء مشاريع جديدة مرة أخرى.",
    "restoreConfirm": "استعادة النوع",
    "toastArchived": "أُرشف {{name}}",
    "toastRestored": "استُعيد {{name}}",
    "empty": "لا توجد أنواع مشاريع بعد.",
    "emptyBody": "أضف الأنواع القياسية وعدّلها، أو أنشئ أنواعك الخاصة.",
    "emptyArchived": "لا توجد أنواع مؤرشفة.",
    "save": "حفظ النوع",
    "saved": "حُفظ {{name}}",
    "internalBilling": "المشاريع الداخلية لا تُفوتر أبدًا.",
    "fields": {
      "code": "الرمز",
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "functions": "الوظائف"
    },
    "errors": {
      "code": "استخدم حتى 20 حرفًا لاتينيًا أو رقمًا أو شرطة أو شرطة سفلية.",
      "name": "أدخل اسم النوع.",
      "billing": "المشروع المنفذ لعميل يُفوتر: اختر طريقة الفوترة.",
      "nodeName": "أدخل اسم الصف.",
      "nodeKey": "استخدم حتى 20 حرفًا لاتينيًا أو رقمًا أو نقطة أو شرطة أو شرطة سفلية.",
      "keyTwice": "هذا المفتاح مستخدم مرتين.",
      "milestoneParent": "لا يمكن أن يكون تحت المعلم الرئيسي صفوف.",
      "parentOrder": "يجب أن يأتي الصف الأعلى قبله في القائمة."
    },
    "template": {
      "title": "قالب الخطة",
      "hint": "الإزاحة والمدة بأيام العمل من تاريخ بداية المشروع.",
      "empty": "لا صفوف: تبدأ مشاريع هذا النوع بخطة فارغة.",
      "row": "صف القالب {{n}}",
      "key": "المفتاح",
      "under": "تحت",
      "topLevel": "المستوى الأعلى",
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "offset": "يبدأ بعد",
      "duration": "المدة",
      "up": "نقل {{key}} إلى الأعلى",
      "down": "نقل {{key}} إلى الأسفل",
      "remove": "إزالة {{key}}",
      "moved": "نُقل {{key}} إلى الموضع {{n}}",
      "removed": "أُزيل {{key}}"
    }
  },
  "costs": {
    "projectLevel": "المشروع كاملًا",
    "archived": "مؤرشفة",
    "budgetsOff": "الموازنات موقوفة لهذا المشروع: التكاليف فقط.",
    "docStatus": {
      "POSTED": "مرحّل",
      "VOID": "ملغى"
    },
    "band": {
      "NONE": "لا موازنة",
      "NORMAL": "ضمن الموازنة",
      "WARN": "قريب من الحد",
      "CRITICAL": "تجاوز الحد"
    },
    "class": {
      "LABOUR": "العمالة",
      "MATERIAL": "المواد",
      "SUBCONTRACT": "مقاولات الباطن",
      "EQUIPMENT": "المعدات",
      "EXPENSE": "المصروفات",
      "OVERHEAD": "المصروفات غير المباشرة",
      "OTHER": "أخرى"
    },
    "source": {
      "purchase": "مشتريات",
      "supplier_return": "مرتجع للمورد",
      "expense": "المصروفات",
      "project_material_issue": "صرف مواد",
      "project_cost_entry": "قيد تكلفة",
      "project_material_return": "إرجاع مواد",
      "sales_invoice": "فاتورة",
      "credit_note": "إشعار دائن",
      "receipt": "سند قبض",
      "project_opening": "الأرقام الافتتاحية",
      "project_claim": "مستخلص",
      "project_retention_forfeit": "التنازل عن المحتجزات",
      "customer_refund": "مبلغ مسترد",
      "project_time_entry": "الوقت"
    },
    "actions": {
      "label": "تسجيل تكلفة",
      "issue": "صرف مواد",
      "return": "إرجاع مواد",
      "entry": "قيد تكلفة جديد",
      "purchase": "مشتريات جديدة",
      "expense": "مصروف جديد"
    },
    "figures": {
      "label": "أرقام الموازنة والتكلفة",
      "budget": "الموازنة",
      "committed": "الملتزم به",
      "committedSub": "مشتريات مسودة",
      "actual": "الفعلي",
      "actualSub": "مستندات مرحّلة",
      "remaining": "المتبقي",
      "remainingSub": "ما زال متاحًا",
      "overSub": "تجاوز الموازنة",
      "use": "الاستخدام",
      "useSub": "تنبيه {{warn}}% · تجاوز {{critical}}%",
      "margin": "الهامش المقدّر"
    },
    "rule": {
      "label": "استُخدم {{use}} من الموازنة؛ تنبيه عند {{warn}}%، تجاوز عند {{critical}}%",
      "rowLabel": "استُخدم {{use}} من الموازنة",
      "budget": "الموازنة",
      "actual": "الفعلي",
      "committed": "الملتزم به"
    },
    "empty": {
      "budgetTitle": "أضف موازنة لترى التكلفة مقارنةً بالخطة",
      "budgetBody": "التكاليف أدناه محسوبة؛ ومع موازنة معتمدة تُظهر كل فئة ما تبقى ونسبة الاستخدام.",
      "costs": "تظهر التكاليف هنا عندما تُربط المشتريات أو المصروفات أو صرف المخزون بهذا المشروع."
    },
    "table": {
      "titleBudget": "الموازنة مقابل التكلفة",
      "titleCost": "التكلفة",
      "views": "تجميع الأرقام",
      "by": {
        "category": "حسب الفئة",
        "node": "حسب أجزاء الخطة",
        "both": "الجزء × الفئة"
      },
      "caption": "الموازنة والتكلفة الملتزم بها والفعلية للمشروع",
      "category": "الفئة",
      "node": "جزء الخطة",
      "nodeCategory": "جزء الخطة والفئة",
      "notInBudget": "خارج الموازنة",
      "total": "الإجمالي"
    },
    "lines": {
      "title": "سطور التكلفة",
      "date": "التاريخ",
      "source": "المستند",
      "sourceType": "نوع المستند",
      "party": "المورد",
      "description": "الوصف",
      "node": "جزء الخطة",
      "category": "الفئة",
      "amount": "المبلغ",
      "draft": "مسودة",
      "notOpenable": "لا يمكنك فتح هذا المستند",
      "open": "فتح المستند",
      "move": "نقل إلى مشروع آخر…",
      "actionsFor": "إجراءات {{number}}",
      "allNodes": "كل أجزاء الخطة",
      "allCategories": "كل الفئات",
      "allSources": "كل المستندات",
      "clear": "مسح عوامل التصفية",
      "noMatch": "لا توجد سطور تكلفة تطابق عوامل التصفية.",
      "kind": "العرض",
      "kindCost": "التكاليف المرحّلة",
      "kindCommitment": "الملتزم به (مشتريات مسودة)",
      "chargedTo": "محمّلة على",
      "noCommitments": "لا توجد مشتريات مسودة مرتبطة بهذا المشروع."
    },
    "card": {
      "title": "الموازنة والتكلفة",
      "open": "فتح الموازنة والتكلفة",
      "used": "المستخدم من الموازنة",
      "error": "تعذّر تحميل الأرقام. افتح الموازنة والتكلفة للمحاولة مجددًا."
    },
    "pickers": {
      "category": "اختر فئة",
      "categorySearch": "ابحث في الفئات…",
      "categoryEmpty": "لا توجد فئة مطابقة.",
      "node": "اختر جزءًا من الخطة",
      "project": "اختر مشروعًا",
      "projectSearch": "ابحث بالرمز أو الاسم…",
      "projectEmpty": "لا يوجد مشروع مفتوح مطابق.",
      "projectError": "تعذّر تحميل المشاريع.",
      "accountSearch": "ابحث في الحسابات…",
      "accountEmpty": "لا يوجد حساب مطابق."
    },
    "void": {
      "reason": "السبب",
      "reasonRequired": "اذكر السبب."
    },
    "errors": {
      "IN_USE": "يوجد مرتجع مرحّل يشير إلى هذا الصرف. ألغِ المرتجع أولًا.",
      "STOCK_ALREADY_USED": "استُخدم المخزون الذي أعاده هذا المستند منذ ذلك الحين، لذا لم يعد إلغاؤه ممكنًا.",
      "INSUFFICIENT_STOCK": "الكمية المتوفرة في هذا المستودع لا تكفي.",
      "VERSION_CONFLICT": "غيّر شخص آخر هذا في الأثناء. أغلقه وافتحه مجددًا ثم أعد تغييرك."
    }
  },
  "budget": {
    "versionName": "الموازنة، الإصدار {{n}}",
    "noBaseline": "لا توجد موازنة معتمدة بعد",
    "openVersion": {
      "DRAFT": "متابعة مسودة الإصدار {{n}}",
      "PENDING": "الإصدار {{n}} بانتظار الاعتماد"
    },
    "status": {
      "DRAFT": "مسودة",
      "PENDING": "بانتظار الاعتماد",
      "APPROVED": "معتمدة",
      "SUPERSEDED": "مستبدلة"
    },
    "editorTitle": "الموازنة، الإصدار {{n}} · {{code}}",
    "editorLoading": "الموازنة",
    "editorDescription": "سطور حسب جزء الخطة وفئة التكلفة؛ الكمية × السعر عند معرفتهما.",
    "preparedBy": "أعدّها {{name}}، {{date}}",
    "statusLine": {
      "direct": "تعتمد خط الأساس بنفسك: الاعتماد يجعل هذا الإصدار هو الموازنة.",
      "second": "تحتاج إلى شخص ثانٍ لديه صلاحية اعتماد الموازنات: قدّمها ثم يعتمدها شخص آخر.",
      "secondPending": "بانتظار شخص ثانٍ لديه صلاحية اعتماد الموازنات.",
      "workflow": "تذهب إلى الاعتماد ({{workflow}}) عند تقديمها.",
      "workflowName": "مسار الاعتماد",
      "workflowAt": "قيد الاعتماد: الخطوة {{index}} من {{total}}، {{step}}.",
      "approved": "خط الأساس منذ {{date}}، اعتمدها {{name}}.",
      "superseded": "استُبدلت بإصدار معتمد لاحق. محفوظة للسجل."
    },
    "actions": {
      "add": "إضافة موازنة",
      "revise": "تعديل الموازنة",
      "save": "حفظ المسودة",
      "submit": "تقديم",
      "approve": "اعتماد",
      "withdraw": "سحب",
      "delete": "حذف المسودة"
    },
    "blocked": {
      "NOT_PERMITTED": "لا يمكنك تنفيذ هذا على هذه الموازنة.",
      "ILLEGAL_MOVE": "غير ممكن من حالتها الحالية.",
      "SELF_APPROVAL": "أنت من أعدّها أو قدّمها: يعتمدها شخص آخر لديه صلاحية اعتماد الموازنات.",
      "APPROVAL_REQUIRED": "اعتماد الموازنات مفعّل: قدّمها بدلًا من ذلك.",
      "WORKFLOW": "يقرّرها مسار اعتماد: اعتمدها من موافقاتي.",
      "REASON_REQUIRED": "اذكر سبب تغيير الموازنة أولًا.",
      "PROJECT_NOT_OPEN": "المشروع مغلق أو ملغى.",
      "FEATURE_OFF": "الموازنات موقوفة لهذا المشروع."
    },
    "fields": {
      "reason": "سبب هذا الإصدار",
      "reasonHint": "مطلوب ابتداءً من الإصدار الثاني: ما الذي تغيّر ولماذا.",
      "reasonOptional": "اختياري للإصدار الأول.",
      "revenue": "الإيراد المخطط",
      "revenueHint": "اتركه فارغًا للمشروع الداخلي."
    },
    "summary": {
      "total": "إجمالي التكلفة",
      "revenue": "الإيراد",
      "margin": "الهامش",
      "change": "التغيّر عن خط الأساس"
    },
    "lines": {
      "label": "سطور الموازنة",
      "add": "إضافة سطر",
      "remove": "حذف السطر {{n}}",
      "hint": "زر الإدخال في السطر الأخير يضيف سطرًا جديدًا.",
      "none": "لا توجد سطور في هذا الإصدار.",
      "node": "جزء الخطة",
      "nodeOf": "جزء الخطة، السطر {{n}}",
      "category": "الفئة",
      "categoryOf": "الفئة، السطر {{n}}",
      "quantity": "الكمية",
      "quantityOf": "الكمية، السطر {{n}}",
      "unit": "الوحدة",
      "unitOf": "الوحدة، السطر {{n}}",
      "rate": "السعر",
      "rateOf": "السعر، السطر {{n}}",
      "amount": "المبلغ",
      "amountOf": "المبلغ، السطر {{n}}",
      "computed": "الكمية × السعر",
      "note": "ملاحظة",
      "noteOf": "ملاحظة، السطر {{n}}",
      "compare": "خط الأساس / الفعلي",
      "new": "جديد",
      "changed": "معدّل",
      "actualShort": "الفعلي"
    },
    "history": {
      "title": "الإصدارات",
      "error": "تعذّر تحميل الإصدارات.",
      "prepared": "أعدّها {{name}}، {{date}}",
      "decided": "اعتمدها {{name}}، {{date}}",
      "picker": "الإصدار"
    },
    "delete": {
      "title": "حذف مسودة الإصدار {{n}}؟",
      "body": "تُحذف المسودة وسطورها. تبقى الموازنة المعتمدة كما هي.",
      "confirm": "حذف المسودة"
    },
    "errors": {
      "fix": "بعض السطور تحتاج إلى مراجعة. تحقق من الحقول المعلّمة."
    },
    "toast": {
      "saved": "حُفظت مسودة الإصدار {{n}}",
      "submit": "قُدّمت الموازنة، الإصدار {{n}}، للاعتماد",
      "approve": "اعتُمدت الموازنة، الإصدار {{n}}: أصبحت خط الأساس",
      "withdraw": "سُحبت الموازنة، الإصدار {{n}}: عادت مسودة",
      "deleted": "حُذفت مسودة الإصدار {{n}}"
    }
  },
  "materials": {
    "title": "صرف المواد",
    "subtitle": "المخزون المصروف للمشاريع والمعاد منها.",
    "kind": {
      "ISSUE": "صرف",
      "RETURN": "إرجاع"
    },
    "backToSource": "إلى حيث حُمّلت أصلًا",
    "backToList": "العودة إلى صرف المواد",
    "openProject": "فتح موازنة المشروع",
    "trail": "الصرف والإرجاع",
    "returnsLabel_zero": "لا مرتجعات",
    "returnsLabel_one": "مرتجع واحد",
    "returnsLabel_two": "مرتجعان",
    "returnsLabel_few": "{{count}} مرتجعات",
    "returnsLabel_many": "{{count}} مرتجعًا",
    "returnsLabel_other": "{{count}} مرتجع",
    "voidTitle": "هذا المستند ملغى",
    "voidLine": "السبب: {{reason}}. ألغاه {{name}}، {{date}}.",
    "createdLine": "{{name}}، {{date}}",
    "fields": {
      "number": "الرقم",
      "date": "التاريخ",
      "kind": "النوع",
      "project": "المشروع",
      "warehouse": "المستودع",
      "warehousePlaceholder": "اختر مستودعًا",
      "node": "جزء الخطة",
      "nodeHint": "أين تُستخدم المواد في الخطة.",
      "category": "فئة التكلفة",
      "categoryHint": "فارغة: الفئة الافتراضية للشركة للمواد المصروفة.",
      "categoryDefault": "الفئة الافتراضية للمواد المصروفة",
      "chargedTo": "محمّلة على",
      "reference": "المرجع",
      "notes": "ملاحظات",
      "value": "القيمة",
      "totalValue": "إجمالي القيمة",
      "status": "الحالة",
      "createdBy": "سُجّل",
      "journal": "القيد"
    },
    "drawer": {
      "title": "صرف مواد أو إرجاعها",
      "titleFor": "مواد المشروع {{code}}",
      "description": "يُرحّل عند الحفظ: يتحرك المخزون ويُحمّل المشروع فورًا.",
      "kind": "صرف أو إرجاع",
      "explain": {
        "ISSUE": "يخرج المخزون من المستودع ويُحمّل على المشروع.",
        "RETURN": "يعود المخزون وتنخفض تكلفة المشروع."
      },
      "posting": "يُرحّل بتاريخ {{date}} على {{project}}.",
      "submit": {
        "ISSUE": "صرف المواد",
        "RETURN": "إرجاع المواد"
      }
    },
    "lines": {
      "label": "المواد",
      "add": "إضافة منتج",
      "remove": "حذف السطر {{n}}",
      "product": "المنتج",
      "productOf": "المنتج، السطر {{n}}",
      "productPlaceholder": "ابحث بالاسم أو رمز الصنف أو الباركود",
      "available": "المتوفر",
      "quantity": "الكمية",
      "quantityOf": "الكمية، السطر {{n}}",
      "serials": "الأرقام التسلسلية",
      "serialList": "الأرقام التسلسلية {{serials}}",
      "returnOf": "مُعاد من",
      "returned": "المُعاد",
      "unitCost": "تكلفة الوحدة",
      "shortage": "المتوفر في هذا المستودع {{quantity}} {{unit}} فقط."
    },
    "return": {
      "title": "ما زال لدى المشروع",
      "search": "ابحث بالمنتج أو المستند",
      "clearSearch": "مسح البحث",
      "none": "لا شيء لدى هذا المشروع: لم تُصرف له مواد ولم تُورَّد إلى موقعه.",
      "chooseProject": "اختر المشروع أولًا لترى ما يمكن إرجاعه.",
      "pick": "إرجاع {{line}}",
      "source": {
        "ISSUE": "مصروف",
        "PURCHASE": "مورَّد إلى الموقع"
      },
      "out": "خرج",
      "back": "عاد",
      "remaining": "المتبقي",
      "unitCost": "تكلفة الوحدة",
      "quantity": "الكمية المعادة",
      "upTo": "حتى {{quantity}}",
      "serials": "الأرقام التسلسلية المعادة",
      "value": "القيمة المعادة"
    },
    "list": {
      "search": "ابحث بالرقم أو المرجع",
      "clearSearch": "مسح البحث",
      "allProjects": "كل المشاريع",
      "allKinds": "الصرف والإرجاع",
      "allStatuses": "أي حالة",
      "allWarehouses": "كل المستودعات",
      "actionsFor": "إجراءات {{number}}",
      "empty": "لم تُصرف مواد للمشاريع بعد.",
      "noMatch": "لا يوجد صرف أو إرجاع يطابق عوامل التصفية."
    },
    "actions": {
      "open": "فتح"
    },
    "void": {
      "action": "إلغاء",
      "title": "إلغاء {{number}}؟",
      "body": {
        "ISSUE": "يعود المخزون إلى المستودع وتُخصم التكلفة من المشروع بتاريخ الصرف.",
        "RETURN": "يخرج المخزون من المستودع مجددًا وتعود التكلفة إلى المشروع بتاريخ الإرجاع."
      },
      "confirm": "إلغاء المستند"
    },
    "errors": {
      "fix": "بعض السطور تحتاج إلى مراجعة. تحقق من الحقول المعلّمة.",
      "project": "اختر المشروع.",
      "overReturn": "الكمية المعادة من {{number}} أكبر مما تبقى لدى المشروع. خفّض الكمية."
    },
    "toast": {
      "ISSUE": "صُرف {{number}}",
      "RETURN": "أُرجع {{number}}",
      "voided": "أُلغي {{number}}"
    },
    "returnFrom": "إرجاع من هذا الصرف",
    "consequence": {
      "issue": "نحو {{amount}} على {{category}}.",
      "issueUse": "نحو {{amount}} على {{category}} (استخدام الموازنة {{use}}% بعد ذلك).",
      "return": "نحو {{amount}} تُخصم من تكلفة المشروع."
    },
    "viewJournal": "عرض القيد",
    "journalPosted": "مرحّل"
  },
  "entries": {
    "title": "قيود التكاليف",
    "subtitle": "التحميل والنقل بين المشاريع والتكاليف الافتتاحية وترحيل العمالة.",
    "backToList": "العودة إلى قيود التكاليف",
    "kind": {
      "ALLOCATION": "تحميل",
      "TRANSFER": "نقل",
      "OPENING": "تكلفة افتتاحية",
      "LABOUR_POSTING": "ترحيل العمالة"
    },
    "explain": {
      "ALLOCATION": "حمّل تكلفة لا مستند لها، مثل معداتك الخاصة أو حصة من المصروفات غير المباشرة، وقيّدها لحساب دائن.",
      "TRANSFER": "انقل التكلفة بين المشاريع أو أجزاء الخطة أو الفئات: اخصمها من سطر (بالسالب) وأضفها إلى آخر.",
      "OPENING": "تكلفة تكبّدها المشروع قبل استخدام النظام. لا يُرحّل شيء إلى الدفاتر.",
      "LABOUR_POSTING": "تكلفة الوقت المعتمد إلى الدفاتر، عبر «ترحيل تكلفة العمالة…» لا بالإدخال اليدوي."
    },
    "posting": {
      "ALLOCATION": "يُرحّل كل سطر إلى حساب تكلفة فئته ويُقيَّد الحساب المختار دائنًا.",
      "TRANSFER": "يُرحّل بين حسابات تكلفة السطور؛ ولا يُرحّل شيء إذا كان الحساب واحدًا.",
      "OPENING": "لا قيد يومية: تُحتسب التكلفة على المشاريع فقط.",
      "LABOUR_POSTING": "يجعل حساب العمالة لكل سطر مدينًا ويقيد الإجمالي دائنًا في الحساب المختار."
    },
    "hidden_zero": "لا توجد سطور على مشاريع لا يمكنك رؤيتها",
    "hidden_one": "سطر واحد على مشروع لا يمكنك رؤيته",
    "hidden_two": "سطران على مشاريع لا يمكنك رؤيتها",
    "hidden_few": "{{count}} سطور على مشاريع لا يمكنك رؤيتها",
    "hidden_many": "{{count}} سطرًا على مشاريع لا يمكنك رؤيتها",
    "hidden_other": "{{count}} سطر على مشاريع لا يمكنك رؤيتها",
    "hiddenBody": "هي جزء من هذا القيد، لكن مشاريعها خارج ما يمكنك فتحه.",
    "costHidden": "المبالغ مخفية: يكشف ترحيل تكلفة العمالة تكلفة ساعة الأشخاص، ورؤيتها تحتاج صلاحية رؤية تكلفة الساعة.",
    "voidTitle": "هذا القيد ملغى",
    "fields": {
      "number": "الرقم",
      "date": "التاريخ",
      "kind": "النوع",
      "description": "الوصف",
      "reference": "المرجع",
      "projects": "المشاريع",
      "amount": "المبلغ",
      "status": "الحالة",
      "creditAccount": "الحساب الدائن",
      "creditAccountHint": "مصدر التكلفة، مثل استرداد المعدات أو المصروفات غير المباشرة المحمّلة.",
      "creditAccountPlaceholder": "اختر حسابًا",
      "posting": "في الدفاتر"
    },
    "drawer": {
      "title": "قيد تكلفة جديد",
      "description": "يُرحّل عند الحفظ. لتغييره لاحقًا ألغِه وسجّله من جديد.",
      "submit": "ترحيل قيد التكلفة"
    },
    "lines": {
      "label": "السطور",
      "add": "إضافة سطر",
      "remove": "حذف السطر {{n}}",
      "project": "المشروع",
      "projectOf": "المشروع، السطر {{n}}",
      "node": "جزء الخطة",
      "nodeOf": "جزء الخطة، السطر {{n}}",
      "category": "الفئة",
      "categoryOf": "الفئة، السطر {{n}}",
      "amount": "المبلغ",
      "signedAmount": "المبلغ (− يخصم)",
      "amountOf": "المبلغ، السطر {{n}}",
      "note": "ملاحظة",
      "noteOf": "ملاحظة، السطر {{n}}",
      "total": "الإجمالي",
      "net": "الصافي",
      "moved": "المنقول"
    },
    "balance": {
      "ok": "مجموع السطور صفر. المبلغ المنقول",
      "off": "يجب أن يكون مجموع سطور النقل صفرًا. الفرق"
    },
    "list": {
      "search": "ابحث بالرقم أو الوصف أو المرجع",
      "clearSearch": "مسح البحث",
      "allKinds": "كل الأنواع",
      "actionsFor": "إجراءات {{number}}",
      "empty": "لا توجد قيود تكاليف بعد.",
      "noMatch": "لا يوجد قيد تكلفة يطابق عوامل التصفية."
    },
    "actions": {
      "open": "فتح"
    },
    "void": {
      "action": "إلغاء",
      "title": "إلغاء {{number}}؟",
      "body": "تُعكس القيود بتاريخ القيد وتُخصم التكلفة من كل مشروع ورد فيه.",
      "confirm": "إلغاء القيد"
    },
    "errors": {
      "fix": "بعض السطور تحتاج إلى مراجعة. تحقق من الحقول المعلّمة.",
      "lines": "{{message}}"
    },
    "toast": {
      "created": "رُحّل {{number}}",
      "voided": "أُلغي {{number}}"
    },
    "move": {
      "title": "نقل التكلفة إلى مشروع آخر",
      "description": "نُقلت من {{code}}: {{description}}"
    },
    "direction": "من {{from}} إلى {{to}}"
  },
  "categories": {
    "new": "فئة جديدة",
    "newTitle": "فئة تكلفة جديدة",
    "editTitle": "تعديل الفئة {{code}}",
    "editorDescription": "كيف تُجمّع تكاليف المشاريع وتُوازن وتُرحّل.",
    "views": "الفئات",
    "active": "النشطة",
    "archived": "المؤرشفة",
    "archivedStamp": "مؤرشفة",
    "listLabel": "فئات التكاليف",
    "emptyActive": "لا توجد فئات تكاليف بعد.",
    "emptyActiveBody": "تُضاف الفئات القياسية الست عند أول تكلفة يسجلها مشروع؛ ويمكنك إضافة فئاتك في أي وقت.",
    "emptyArchived": "لا توجد فئات مؤرشفة.",
    "defaultAccount": "حساب تكاليف المشاريع الافتراضي",
    "billable": "قابلة للفوترة افتراضيًا",
    "progressExcluded": "مستثناة من إنجاز التكلفة",
    "edit": "تعديل {{name}}",
    "archive": "أرشفة {{name}}",
    "restore": "استعادة {{name}}",
    "archiveTitle": "أرشفة {{name}}؟",
    "archiveBody": "تبقى على التكاليف والموازنات المسجلة، لكن لا يمكن للسطور الجديدة استخدامها.",
    "archiveConfirm": "أرشفة",
    "restoreTitle": "استعادة {{name}}؟",
    "restoreBody": "يمكن اختيارها مجددًا على التكاليف وسطور الموازنة الجديدة.",
    "restoreConfirm": "استعادة",
    "save": "حفظ الفئة",
    "fields": {
      "code": "الرمز",
      "codeHint": "أحرف وأرقام وشرطة وشرطة سفلية؛ يظهر في القوائم والتقارير.",
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "class": "النوع",
      "classHint": "نوع التكلفة التي تضمها؛ تعرض المشاريع التكلفة حسب النوع.",
      "account": "حساب التكلفة",
      "accountHint": "حساب مصروفات للبضائع الموردة إلى المواقع والمواد المصروفة وقيود التكاليف في هذه الفئة.",
      "billable": "قابلة للفوترة افتراضيًا",
      "billableHint": "تُفوتر تكاليفها في مشاريع الوقت والمواد ما لم يُحدد خلاف ذلك.",
      "progressExcluded": "استثناء من إنجاز التكلفة",
      "progressExcludedHint": "للتكاليف التي تسبق العمل، مثل المواد المشتراة مبكرًا."
    },
    "toast": {
      "saved": "حُفظت الفئة {{code}}",
      "archived": "أُرشفت الفئة {{code}}",
      "restored": "استُعيدت الفئة {{code}}"
    },
    "map": {
      "title": "أي فئة تأخذها التكلفة",
      "body": "عندما يترك الموظف الفئة فارغة، تُؤخذ من فئة المنتج ثم من حساب السطر ثم من فئة المصروف؛ وإلا فمن الافتراضيات في الإعدادات › المشاريع.",
      "kind": {
        "PRODUCT_CATEGORY": "فئات المنتجات",
        "ACCOUNT": "الحسابات",
        "EXPENSE_CATEGORY": "فئات المصروفات"
      },
      "hint": {
        "PRODUCT_CATEGORY": "المنتج في فئة فرعية يأخذ أقرب فئة مربوطة أعلاه.",
        "ACCOUNT": "لسطور مشتريات الخدمات والنص الحر.",
        "EXPENSE_CATEGORY": "للمصروفات المرتبطة بمشروع."
      },
      "pick": {
        "PRODUCT_CATEGORY": "اختر فئة منتجات",
        "ACCOUNT": "اختر حسابًا",
        "EXPENSE_CATEGORY": "اختر فئة مصروفات"
      },
      "none": "لا شيء مربوط.",
      "search": "ابحث…",
      "noSource": "لم يبقَ ما يُربط.",
      "category": "فئة التكلفة",
      "categoryFor": "فئة التكلفة لـ {{name}}",
      "remove": "إزالة ربط {{name}}",
      "add": "إضافة",
      "cannotRead": "لا يمكنك قراءة هذه القائمة، لذا لا يمكن ربطها هنا.",
      "discard": "تجاهل التغييرات",
      "save": "حفظ الربط",
      "saved": "حُفظ الربط"
    },
    "classLine": "النوع: {{class}}"
  }
}
